import { NRLogger as s } from "./contact-channels40.js";
import { attempt as a } from "./contact-channels49.js";
const h = async (r, e) => {
  const { data: t, error: o } = await a(
    fetch(
      `https://care-hub.care.vpsvc.com/${r == null ? void 0 : r.toLowerCase()}/${e == null ? void 0 : e.toLowerCase()}/helpcenter/banner/status`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      }
    )
  );
  if (o)
    throw s.error("Contact Channels: Emergency Check", {
      ...o,
      locale: e,
      tenant: r
    }), o;
  if (!t.ok)
    throw s.error("Contact Channels: Emergency Check", {
      status: t.status,
      message: "Failed to fetch EmergencyData"
    }), new Error(`HTTP error! Status: ${t.status}`);
  return t.json();
};
export {
  h as getEmergencyData
};
//# sourceMappingURL=contact-channels36.js.map
